import { userReducer } from './user.reducer';
import { signInEpic } from './epics/signIn.epic';
import { persistUserEpic } from './epics/persist.epic';
import { hydrateEpic } from './epics/hydrate.epic';
import { refreshEpic } from './epics/refresh.epic';
import { resetUserState } from './epics/resetUserState.epic';
import { createAccountEpic } from './epics/register.epic';

const NAME = 'user';

export function userRegister() {
    return {
        epics: [
            resetUserState,
            hydrateEpic,
            persistUserEpic,
            signInEpic,
            // // signOutOnPageView,
            refreshEpic,
            createAccountEpic,
        ],
        reducers: { [NAME]: userReducer },
        name: NAME,
    };
}
